// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ol-0";